interface HeadingProps {
    title: string;
    subtitle?: string;
    as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
    align?: "left" | "center" | "right";
    className?: string;
}

import styles from "./FormHeading.module.scss"

const FormHeading = ({
    title,
    subtitle,
    as = "h1",
    align = "left",
    className = "",
}: HeadingProps) => {
    const Tag = as;

    const alignmentClass = {
        left: styles.alignLeft,
        center: styles.alignCenter,
        right: styles.alignRight,
    }[align]

    const titleSizeClass = {
        h1: styles.h1,
        h2: styles.h2,
        h3: styles.h3,
        h4: styles.h4,
        h5: styles.h5,
        h6: styles.h6,
    }[as]

    return (
        <div className={`${styles.wrapper} ${alignmentClass} ${className ?? ""}`}>
            <Tag className={`${styles.titleBase} ${titleSizeClass}`}>{title}</Tag>

            {subtitle && (
                <p className={styles.subtitle}>{subtitle}</p>
            )}
        </div>
    );
};

export default FormHeading;